export default __webpack_public_path__ + "static/media/active.8d749356.svg";